import React from "react";
import Link from "next/link";

const Logo: React.FC = () => {
  return (
    <Link href="/" aria-label="Notive home">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 980 150"
        width="150"
        height="23"
        className="relative cursor-pointer fill-current text-white"
        aria-hidden
      >
        <path d="M979.972 147.646L885.398 147.571L885.519 2.9043L976.421 2.97698L976.398 30.2882L920.258 30.2438L920.233 61.396L972.27 61.4378L972.249 87.2553L920.212 87.2147L920.184 119.861L979.994 119.909L979.972 147.646Z" />
        <path d="M811.003 147.511L779.693 147.485L723.242 2.77441L759.085 2.80268L795.487 109.305L831.634 2.86055L867.261 2.88889L811.003 147.511Z" />
        <path d="M705.094 147.426L670.332 147.398L670.451 2.73145L705.214 2.75978L705.094 147.426Z" />
        <path d="M609.447 147.351L574.683 147.323L574.781 30.1818L532.461 30.1473L532.483 2.62305L651.887 2.7179L651.865 30.2434L609.544 30.2089L609.447 147.351Z" />
        <path d="M457.449 150C412.754 149.964 384.707 121.777 384.746 74.8356C384.785 28.5329 412.878 -0.0356788 457.573 3.34425e-05C502.053 0.0357457 530.099 28.6499 530.061 74.9514C530.022 121.893 501.929 150.036 457.449 150ZM457.473 121.408C482.088 121.428 494.841 104.155 494.865 74.923C494.89 45.6907 482.165 27.9713 457.55 27.9516C432.936 27.9319 419.965 45.6316 419.941 74.8639C419.918 104.095 432.858 121.388 457.473 121.408Z" />
        <path d="M360.2 147.149L323.494 147.12L264.839 55.9623L264.763 147.073L230 147.044L230.12 2.37793L265.747 2.40627L325.479 95.912L325.557 2.45429L360.32 2.48263L360.2 147.149Z" />
        <path d="M0.128906 99.917H50.0873V149.875H0.128906V99.917Z" />
        <path d="M100.043 0H150.001V49.9585L100.043 0Z" />
        <path d="M0 0C19.6983 -8.6105e-07 39.2038 3.87985 57.4025 11.4181C75.6013 18.9563 92.1373 30.0053 106.066 43.934C119.995 57.8628 131.044 74.3988 138.582 92.5975C146.12 110.796 150 130.302 150 150H98.1018C98.1018 137.117 95.5645 124.36 90.6343 112.458C85.7043 100.556 78.478 89.741 69.3685 80.6315C60.259 71.522 49.4443 64.2958 37.542 59.3658C25.6398 54.4355 12.8829 51.898 2.5034e-06 51.8983L0 0Z" />
      </svg>
    </Link>
  );
};

export default Logo;
